import { defineMessages } from "react-intl";

const PREFIX = "PeriodSelectorControl";
const messages = defineMessages({
  selectAllButtonLabel: {
    id: `${PREFIX}.selectAllButtonLabel`,
    defaultMessage: "Select all",
  },
  unselectAllButtonLabel: {
    id: `${PREFIX}.unselectAllButtonLabel`,
    defaultMessage: "Unselect all",
  },
  apllyButtonLabel: {
    id: `${PREFIX}.apllyButtonLabel`,
    defaultMessage: "Apply",
  },
  cancelButtonLabel: {
    id: `${PREFIX}.cancelButtonLabel`,
    defaultMessage: "Cancel",
  },
  xAxis: {
    id: `${PREFIX}.xAxis`,
    defaultMessage: "X Achse",
  },
  yAxis: {
    id: `${PREFIX}.yAxis`,
    defaultMessage: "Y Achse",
  },
});

export default messages;
